import { RouteType } from "./config";

import errorRoutes from "src/pages/ErrorsPages/ErrorPageRoutes";
import pagesRoutes from "src/pages/PagesRoutes";

const appRoutes: RouteType[] = [
    ...errorRoutes,
    ...pagesRoutes
];

export default appRoutes;
